module.exports = __webpack_public_path__ + "static/pillar-platform-fecc705adacb05ab3dbd5268b2316c7b.jpg";